import React from "react";
import ReactDOM from "react-dom";

import Appwalls from "../components/Appwalls";
// import Offerwalls from "../components/Offerwalls";
const appwallsElement = document.getElementById('Appwalls');
if (appwallsElement) {
    const props = JSON.parse(appwallsElement.getAttribute('data-props'));
    ReactDOM.render(<Appwalls {...props} />, appwallsElement);
}
